import React from 'react'
import styled from "@emotion/styled";
import {Link} from "react-router-dom";
import sv from "../../styles/marketing";

// STYLE ##########################################################

export const exampleContainerWidth = 270; // includes 250 for an example and 20 left padding

const Example = styled(`div`)`
  cursor: pointer;
  max-width: 250px;
  margin: 0 0 20px ${props => props.firstMargin ? "20px" : "0"};
`;

const ImageContainer = styled(`div`)`
  width: 250px;
  height: 140px;
  overflow: hidden;
  background: black;
`;

const ExImage = styled(`img`)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ExTitle = styled(`p`)`
  margin-top: 5px;
  color: ${sv.colors.darkerGray}
`;

// COMPONENT ##########################################################

export const ExampleInstance = ({ exampleInstance, firstMargin = true }) => {
  return (
      <Link to={{pathname: exampleInstance.link}} target="_blank">
        <Example firstMargin={firstMargin}>
          <ImageContainer>
            <ExImage src={exampleInstance.imageSrc}/>
          </ImageContainer>
          <ExTitle>{exampleInstance.title}</ExTitle>
        </Example>
      </Link>
  );
}
